// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__16p6M","inner":"Form_inner__2BLPr","range":"Form_range__18WnW","name":"Form_name__TTpCU","actions":"Form_actions__20HaO"};